import { Text } from '@huspy/briks-web';
import { Tooltip as MantineTooltip } from '@mantine/core';
import briksTheme from '@shared/briks-theme';
import React from 'react';

type Props = React.ComponentProps<typeof MantineTooltip>;
const Tooltip = (props: Props) => (
  <MantineTooltip
    withArrow
    multiline
    arrowSize={ 12 }
    color={ briksTheme.colors['rebu.950'] }
    p={ briksTheme.spacing['1,5'] }
    transitionProps={ { transition: 'pop', duration: 300 } }
    styles={ { tooltip: { borderRadius: '8px' } } }
    { ...props }
    // eslint-disable-next-line react/destructuring-assignment
    label={ <Text size='sm'>{props.label}</Text> }
  />
);

export default Tooltip;
